import React, { Component } from 'react';
import pageSwitch, { PageSwitch } from 'pageswitch';
import $ from 'jquery';
import classlist from 'utils/classlist';

import './style.scss';

interface ISliderProps {
    className?: string;
}

class Slider extends Component<ISliderProps> {
    bannerNode: HTMLDivElement;
    slider: PageSwitch;

    componentDidMount() {
        const slides = this.bannerNode.querySelector('.slides');

        this.setSlider(slides, this.bannerNode);
    }

    componentWillUnmount() {
        this.slider.destroy();
    }

    setSlider = (elem, parent) => {
        const transName: 'scroll' | 'fade' = window.innerWidth <= 540 ? 'scroll' : 'fade';
        const slider = (this.slider = new pageSwitch(elem, {
            transition: transName,
            autoplay: 1,
            direction: 0,
            duration: 1000,
            interval: 6000,
            loop: true
        }));

        const navs = $(
            `<div class="navs">${$.map(slider.pages, () => {
                return '<span></span>';
            }).join('')}</div>`
        )
            .appendTo(parent)
            .children();

        navs.eq(slider.current).addClass('active');

        // 绑定点选播放
        navs.on('click', function() {
            slider.slide($(this).index());
        });

        slider.on('before', (prev, now) => {
            navs.eq(prev).removeClass('active').end().eq(now).addClass('active');
        });
    };

    banner = node => {
        this.bannerNode = node;
    };

    render() {
        const { className, children } = this.props;

        return (
            <div className={classlist('section slider-root', className)} ref={this.banner}>
                <div className="slides">{children}</div>
            </div>
        );
    }
}

export default Slider;
